// store/modules/portal.js (新增模块)
const state = {
    enableRegistration: false,
    configLoaded: false
};

const mutations = {
    SET_ENABLE_REGISTRATION(state, enabled) {
        state.enableRegistration = enabled;
    },
    SET_CONFIG_LOADED(state, loaded) {
        state.configLoaded = loaded;
    }
};

const actions = {
    setRegistrationEnabled({ commit }, enabled) {
        commit('SET_ENABLE_REGISTRATION', enabled);
    },
    setConfigLoaded({ commit }, loaded) {
        commit('SET_CONFIG_LOADED', loaded);
    }
};

const getters = {
    isRegistrationEnabled: (state) => state.enableRegistration,
    isConfigLoaded: (state) => state.configLoaded
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};